import { Api } from "@/api/base";
import { productBarcodeUrl } from "@/api/productBarcode/urls";

const productBarcodeApi = {
  getByProductId: async (id) => Api.get(productBarcodeUrl.getByProductId(id)),
};

export { productBarcodeApi };
